import type { ThemeOptions } from '@mui/material';

import { blue } from '~/styles/colors';

declare module '@mui/material/Link' {
  interface TypographyPropsVariantOverrides {
    mono: true;
  }
}

const LinkTheme: ThemeOptions['components'] = {
  MuiLink: {
    styleOverrides: {
      root: {
        textDecoration: 'none',
        color: blue[500],
      },
    },
    variants: [
      {
        props: { variant: 'mono' },
        style: {
          fontFeatureSettings: "'tnum' on, 'lnum' on, 'ss03' on",
          fontWeight: 400,
          letterSpacing: '-0.01em',
          lineHeight: '140%',
          fontFamily: 'GT America Mono',
          fontSize: '16px',
        },
      },
    ],
  },
};

export default LinkTheme;
